// extracted by mini-css-extract-plugin
export default {"expiredStepWrapper":"ExpiredStep_expiredStepWrapper__ACUbz","title":"ExpiredStep_title__+oODO","text":"ExpiredStep_text__HpCQ6","warningIcon":"ExpiredStep_warningIcon__X1kFD"};